import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import PropTypes from 'prop-types';
import React from 'react';

/**
 * An option is either a string, or a { value, label } pair.
 *
 * A plain string is both what is shown and what comes back, which is all most
 * callers need. It is not enough when the label is a name and the answer has to
 * be an id: the account selector reads back what the user picked and asks the
 * API to switch to it, and matching a name to a row is only correct while no
 * two rows share a name. The pair form keeps the two apart, so what comes back
 * out of `onChange` is the identity, not the text.
 */
const asPair = option =>
  typeof option === 'string' ? { value: option, label: option } : option;

const Component = props => {
  const { options, value } = props;
  const { onChange } = props;

  const handleChange = event => {
    onChange(event.target.value);
  };

  return (
    <RadioGroup
      //ref={radioGroupRef}
      aria-label="ringtone"
      name="ringtone"
      value={value}
      onChange={handleChange}
    >
      {options.map(asPair).map(({ label, value: optionValue }) => (
        <FormControlLabel
          value={optionValue}
          key={optionValue}
          control={<Radio color='primary'/>}
          label={label}
        />
      ))}
    </RadioGroup>
  );
};

Component.propTypes = {
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({ label: PropTypes.string, value: PropTypes.string })
  ])).isRequired,
  value: PropTypes.string,
};

export default Component;
